"use client";

import { useEffect, useRef, useState } from "react";

// Viewport gate for chart animations. Renders as display:contents so it
// never affects layout; once the first child scrolls into view, `in-view`
// is added and the .anim-* zero-state overrides in globals.css release,
// letting each element transition to its inline value.
export default function Reveal({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    // display:contents has no box — observe the real child instead.
    const el = ref.current?.firstElementChild;
    if (!el) {
      setInView(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      style={{ display: "contents" }}
      className={`chart-reveal ${inView ? "in-view" : ""}`}
    >
      {children}
    </div>
  );
}
